
export function Floor(rooms = []) {
    return {
        id: `floor-${Date.now()}`,
        rooms
    };
}

export function addRoom(floor, room) {
    return { ...floor, rooms: [...floor.rooms, room] };
}

export function removeRoom(floor, roomId) {
    return { ...floor, rooms: floor.rooms.filter(room => room.id !== roomId) };
}
